<template>
	<div @mouseover="ResetTimeOutTimer">
		<div v-if="test">
			<b-modal id="addModel" v-model="showModal" title="Session Timeout" size="sm" centered>
				<div class="dropdown-divider bg-dark"></div>
				<p class="font-weight-normal">
					You're being logged out due to inactivity. <br />
					Please choose to stay signed in or to logoff. <br />
					Otherwise you will loqout automatically.
				</p>
				<div class="dropdown-divider bg-dark"></div>
				<template #modal-footer>
					<div>
						<base-button type="button" class="btn btn-light" @click="IdleTimeout"> Log out</base-button>
						<base-button type="button" class="btn btn-primary" @click="ResetTimeOutTimer">
							Stay Logged In {{ timoutWarning / 1000 }}
						</base-button>
					</div>
				</template>
			</b-modal>
		</div>
		<!--no-close-on-backdrop-->
		<b-modal
			centered
			size="sm"
			id="modal_activity_progress_bar"
			hide-footer
			hide-header
			class="modal_activity_progress_bar"
		>
			<p class="h1 text-center mb-4">Activity</p>
			<b-progress
				:value="progressStartValue"
				height="16px"
				variant="primary"
				:striped="true"
				v-if="showProgressMeter"
				class="mt-2"
				:animated="true"
				show-progress
			></b-progress>
			<div align="center" class="text-center justify-content-center">
				<b-icon
					icon="three-dots"
					class="text-center"
					animation="cylon"
					font-scale="4"
					v-if="!showProgressMeter"
				></b-icon>
				<br />
				<small class="text-center" v-if="progressTitle">{{ progressTitle }}</small>
				<br />
				<small class="text-center" v-if="progressMessage">{{ progressMessage }}</small>
			</div>
		</b-modal>
		<div
			class="wrapper"
			:style="logoutStatus ? '-webkit-filter: blur(5px) grayscale(60%);background: rgba(0, 0, 0, 0.3);' : ''"
		>
			<notifications position="bottom center" />
			<side-bar class="sidenav-custom">
				<template slot="links">
					<!-- eslint-disable -->
					<div>
						<sidebar-item
							v-for="(items, index) in sideBar"
							v-bind:key="index"
							:link="{
								name: items.name,
								icon: items.icon,
								path: items.path,
							}"
						>
							<sidebar-item
								v-if="items.child"
								v-for="(children, index) in items.child"
								v-bind:key="index"
								:link="{
									name: children.name,
									icon: children.icon,
									path: children.path,
								}"
							></sidebar-item>
						</sidebar-item>
					</div>
					<!-- eslint-enable -->

					<div>
						<nav class="">
							<a href="#" class="nav-link" v-on:click="onLogOut()">
								<i class="fa fa-sign-out-alt"></i>
								<span class="nav-link-text">Logout</span>
							</a>
						</nav>
					</div>
				</template>
			</side-bar>
			<div class="main-content">
				<div
					align="center"
					id="routerAlerts"
					style="position: fixed; top: 2%; right: 0%; z-index: 100; width: 100%"
				></div>
				<dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

				<div class="bottom-to-bottom">
					<div @click="$sidebar.displaySidebar(false)" style="margin-top: 4.9rem" class="main-content-custom">
						<fade-transition :duration="200" origin="center top" mode="out-in">
							<!-- your content here -->
							<router-view></router-view>
						</fade-transition>
					</div>
					<content-footer v-if="!$route.meta.hideFooter"></content-footer>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
/* eslint-disable no-new */
import {mapGetters} from "vuex";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
//import DashboardContent from './Content.vue';
import {FadeTransition} from "vue2-transitions";
import initService from "../../common/api-services/init-service";
import configDirective from "../../common/directive/config-directive";
import AuthService from "@/common/api-services/auth-service";
import {LOGOUT} from "@/store/auth.module";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		new PerfectScrollbar(`.${className}`);
	} else {
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

let VUE_APP_SESSION_TIMEOUT_MINUTES = `${process.env.VUE_APP_SESSION_TIMEOUT_MINUTES}`;
export default {
	name: "dashboard-layout",
	components: {
		DashboardNavbar,
		ContentFooter,
		//    DashboardContent,
		FadeTransition,
	},
	data() {
		return {
			sideBar: [],
			isReadOnly: false,
			isAdmin: false,
			logoutStatus: false,
			timer: null,
			progressStartValue: 0,
			progressTitle: "",
			progressMessage: "",
			showProgressMeter: true,
			//
			test: false,
			authUser: false,
			showModal: false,
			timoutWarning: 0,
			warningTimer: "",
			timeoutTimer: "",
			isMounted: false,
		};
	},

	methods: {
		initScrollbar() {
			let isWindows = navigator.platform.startsWith("Win");
			if (isWindows) {
				initScrollbar("sidenav");
			}
		},

		async onLogOut() {
			this.$router.push({name: "login"});
			setTimeout(() => {
				initService.clearCache();
			}, 400);
			AuthService.logoutService().then(res => {
				this.$store.dispatch(LOGOUT).then(() => this.$router.push({name: "login"}).catch(() => {}));
			});
		},

		setProgressTimer() {
			this.timer = setInterval(() => {
				this.progressStartValue = this.progressStartValue + (Math.random() * 300) / this.progressStartValue;
				if (this.progressStartValue > 100) {
					this.progressStartValue = 10;
				}
			}, 1000);
		},
		startWarningTimer() {
			this.timoutWarning = 10000;
			let timerId = null;
			if (this.isAuthenticated || this.timoutWarning !== 0) {
				if (this.isIdle) {
					timerId = setInterval(() => {
						this.timoutWarning -= 1000;
						if (this.timoutWarning < 11000) {
							this.showModal = true;
							this.$bvModal.show("addModel");
						}
						if (this.timoutWarning < 1) {
							clearInterval(timerId);
							this.showModal = false;
							this.IdleTimeout();
						}
					}, 1000);
				} else {
					clearInterval(this.timoutWarning);
				}
			}
		},
		ResetTimeOutTimer() {
			this.showModal = false;
			this.timoutWarning = VUE_APP_SESSION_TIMEOUT_MINUTES * 60000;
		},
		IdleTimeout() {
			this.$root.$emit("logoutEvent", true);
		},
		callTimerStart() {
			if (this.isIdle == true) {
				this.startWarningTimer();
			} else {
				this.ResetTimeOutTimer();
			}
		},
	},

	mounted() {
		// Global Usage
		//Vue.analytics.trackView(this.$route.name);

		if (!this.isAuthenticated) {
			this.$router.push({name: "login"}).catch(() => {});
			sessionStorage.clear();
		}
		this.initScrollbar();

		//this will always send to login if we don't have config data.
		let config = configDirective.getConfigData();
		if (!config || config.length < 25) {
			this.$router.push({name: "login"}).catch(() => {});
			sessionStorage.clear();
		}

		this.isPortalAdminStatus = initService.getPortalAdminRole();
		this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
		const groups = initService.getGroups();

		this.$root.$on("logoutEvent", res => {
			if (res) {
				this.logoutStatus = true;
				//modal_activity_progress_bar
				this.progressTitle = "Please wait while we process your action.";
				this.progressMessage = "";
				this.showProgressMeter = false;
				this.$bvModal.show("modal_activity_progress_bar");

				//force clear.
				sessionStorage.clear();
				this.$router.push("/login");
				window.location.href = "/login";
			}
		});

		this.$root.$on("loadingPanelShow", res => {
			// console.log('loading panel show:', res);
			if (res) {
				this.logoutStatus = true;
				//modal_activity_progress_bar
				this.progressTitle = "Please wait while we process your action.";
				this.progressMessage = "";
				this.showProgressMeter = false;
				this.$bvModal.show("modal_activity_progress_bar");
			}
		});

		this.$root.$on("loadingPanelHide", res => {
			//console.log('loading panel hide:', res);
			if (res) {
				this.logoutStatus = false;
				//modal_activity_progress_bar
				this.$bvModal.hide("modal_activity_progress_bar");
			}
		});

		this.$root.$on("loadingPanelUpdate", res => {
			//console.log('loading panel update:', res);
			if (res) {
				this.logoutStatus = true;
				//modal_activity_progress_bar
				if (res.title) this.progressTitle = res.title;
				if (res.message) this.progressMessage = res.message;
				if (res.progress) this.showProgressMeter = res.progress;
				this.$bvModal.show("modal_activity_progress_bar");
			}
		});
	},
	created() {
		this.isMounted = this.isAuthenticated;
		this.test = this.isAuthenticated;
		this.callTimerStart(); // We have to call it due to any activity
	},
	computed: {
		...mapGetters(["isAuthenticated"]),
		currentRouteName() {
			return this.$route.name;
		},
		isIdle() {
			return this.$store.state.idleVue.isIdle;
		},
	},
	watch: {
		isIdle(c) {
			if (c) {
				this.callTimerStart();
			}
		},
	},
};
</script>
<style lang="postcss">
.overlay {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 100;
	display: flex;
	align-items: center;
	justify-content: center;
}

.modal {
	width: 500px;
	box-shadow: 1px 2px 4px rgba(153, 155, 168, 0.12);
	border-radius: 4px;
	@apply bg-white p-2;
}

.modal__title {
	color: #38404f;
	@apply flex items-center justify-between p-3 font-bold;
}

.fixed-bottom-sidenav {
	position: fixed;
	bottom: 0px;
}
</style>
